import useScroll from "~/compositions/useScroll";
import { isset } from "~/utils/helpers";
export default class GoToTopButton {
    goToTopButton;
    timeout = null;
    constructor() {
        this.goToTopButton = document.querySelector('.js-go-to-top-button');
        const { scrollY, scrollCallback, nativeInit } = useScroll(16, false);
        scrollCallback.value = () => {
            this.scrolled(scrollY.value);
        };
        nativeInit();
        this.scrolled(window.scrollY);
    }
    scrolled(scrollY, recall = false) {
        this.goToTopButton = document.querySelector('.js-go-to-top-button');
        if (this.goToTopButton) {
            if (scrollY > (window.visualViewport?.height || 0)) {
                this.goToTopButton.classList.add('is-active');
            }
            else {
                this.goToTopButton.classList.remove('is-active');
            }
        }
        if (!recall) {
            if (isset(this.timeout) && this.timeout !== null) {
                clearTimeout(this.timeout);
            }
            this.timeout = setTimeout(() => {
                this.scrolled(scrollY, true);
            }, 500);
        }
    }
}
